import { cn } from '@/lib/utils';

interface EmptyStateProps {
  /** Lucide icon to display centred above the message. */
  icon?: React.ReactNode;
  /** One-line headline. Use plain language — the user is here because *nothing matched*. */
  title: string;
  /** Optional supporting line. Tell them what would change the result. */
  hint?: string;
  className?: string;
}

/**
 * Standard empty-state for tables, filtered lists, and search results.
 * The intent: don't render a bare `<p>No results</p>` — give a small visual
 * anchor and a hint that points at the next action.
 */
export function EmptyState({ icon, title, hint, className }: EmptyStateProps): JSX.Element {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-2 py-12 text-center text-sm text-muted-foreground',
        className,
      )}
    >
      {icon && <span className="text-muted-foreground/70">{icon}</span>}
      <p className="font-medium text-foreground/80">{title}</p>
      {hint && <p className="max-w-[55ch] text-xs">{hint}</p>}
    </div>
  );
}
